  <template>
  <div class="yk-interactions__container yk-interactions__container-new">
    <div class="yk-interactions--header headClearfix">
      <div class="yk-intera-head-form">
        <el-input placeholder="请输入作业名称查询"
                  class="input-with-select change-search-in-wrapper-1"
                  v-model="paperName"
                  @keyup.enter.native='getPaperList'>
          <i slot="suffix"
             class="el-input__icon el-icon-search"
             @click="getPaperList()"></i>
        </el-input>
        <!-- <el-button size="small"
                   type="primary"
                   @click="backtoclass"
                   class="yk-btn-new yk-btn-new-back-s"
                   icon="wl-icon-fanhui2"></el-button> -->
      </div>
    </div>
    <div class="clearfix"
         style="padding:0 40px;margin-top:20px;">
      <div class="yk-add-paper-btn-wrapper"
           @click="sureAddPaper(1)">
        <i class="wl-icon-tianjia1"></i>
        <span>
          新增题库作业
        </span>
      </div>
      <div class="yk-add-paper-btn-wrapper yk-add-paper-btn-wrapper1"
           @click="sureAddPaper(4)">
        <i class="wl-icon-tianjia1"></i>
        <span>
          新增附件作业
        </span>
      </div>
      <div class="yk-add-paper-btn-wrapper yk-add-paper-btn-wrapper2"
           @click="sureAddPaper(2)">
        <i class="wl-icon-tianjia1"></i>
        <span>
          新增登分作业
        </span>
      </div>
    </div>
    <div class="yk-interactions--inner-s">
      <el-table ref="multipleTable"
                :data="list"
                stripe
                class="yk-table-dark"
                tooltip-effect="dark"
                empty-text=" ">
        <el-table-column label="序号"
                         type="index"
                         width="50">
        </el-table-column>
        <el-table-column prop="PaperName"
                         label="作业名称">
        </el-table-column>
        <el-table-column prop="CreatorName"
                         label="创建人">
        </el-table-column>
        <el-table-column label="作业类型">
          <template slot-scope="scope">
            <span :style="{color: scope.row.PaperType === 1 ? '#31C27C': scope.row.PaperType===2 ?'#F83C6D':'#3F9FFB'}">{{scope.row.PaperType === 1 ? '题库作业':scope.row.PaperType === 2 ?'登分作业':"附件作业"}}</span>
          </template>
        </el-table-column>
        <el-table-column label="总分">
          <template slot-scope="scope">
            <span>{{scope.row.TotalScore}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="180">
          <template slot-scope="scope">
            <el-button size="mini"
                       v-if="scope.row.PaperType !=2"
                       @click="checkhomework(scope.row.PaperType,scope.row.Id)"
                       icon="wl-icon-chakan"
                       type="primary"
                       title="查看"></el-button>
            <el-button size="mini"
                       v-if="scope.row.PaperType == 2"
                       @click="editActivity(scope.row)"
                       icon="el-icon-edit"
                       type="primary"
                       title="编辑"></el-button>
            <el-button size="mini"
                       @click="openDetails(scope.row.PaperType,scope.row.Id)"
                       icon="el-icon-edit"
                       title="编辑"
                       type="primary"
                       v-if="scope.row.PaperType != 2"></el-button>
            <el-button size="mini"
                       type="danger"
                       @click="delPaper(scope.row.Id)"
                       icon="el-icon-delete"
                       title="删除"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="noDataShow"
           class="yk-nodata-source-content ">
        <img src="~assets/images/the-last-new-nodata-imag.png"
             alt=""
             class="yk-prompt">
      </div>
    </div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="onPageChangeHandler"
      :current-page="pageIndex"
      :page-sizes="[6 , 10, 15, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      v-show="totalCount>0">
    </el-pagination>

    <el-dialog class="yk-ccs-dialog"
               title="新增作业"
               :visible.sync="dialogForAddPaper"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="40%">
      <el-form label-width="6em">
        <el-form-item label="作业类型：">
          <el-radio v-model="addType"
                    label="1">题库作业</el-radio>
          <el-radio v-model="addType"
                    label="2">登分作业</el-radio>
          <el-radio v-model="addType"
                    label="4">附件作业</el-radio>
        </el-form-item>
        <el-form-item label="作业名称：">
          <el-input auto-complete="off"
                    v-model="addName"
                    style="width:90%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancelAddPaper()">取 消</el-button>
        <el-button type="primary"
                   @click="sureAddPaper()">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑-->
    <el-dialog class="yk-ccs-dialog"
               title="修改作业"
               :visible.sync="editdialogForAddPaper"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form>
        <el-form-item label="作业名称：">
          <el-input auto-complete="off"
                    v-model.trim="editName"
                    style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="作业总分：">
          <el-input auto-complete="off"
                    v-model="TotalScore"
                    style="width:400px"
                    type="number"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancelAddPaper()">取 消</el-button>
        <el-button :disabled="disabled"
                   type="primary"
                   @click="sureEditPaper()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    courseId: {
      type: String,
      default: ''
    },
    state: {
      type: String,

      default: '0'
    },
    isShow: {
      type: Boolean,
      default: ""
    },
    importCourseVisible: {
      type: Boolean,
      default: false
    },
    IsAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** 分页 */
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      /** 查询条件 */

      paperType: '',
      paperName: '',
      /** 返回列表 */
      list: [],
      /** 新建弹窗 */
      dialogForAddPaper: false,
      editdialogForAddPaper: false,

      editActivityId: '',
      addType: '1',
      addName: '',
      editName: '',
      TotalScore: 0,
      /** */

      /* 颜色改变 */
      active: 1,
      menuShow: false,
      disabled: false,
      newCourseId: this.$route.params.courseId,

      myid: '',
      otherid: '',
      noDataShow: false,
      loadingShow: false,
      importDialog: false,
      ids: []
    };
  },
  components: {
    // ManagerShare
    // importPaper
  },
  created() {
    this.getPaperList(1);
  },
  methods: {
    backtoclass: function() {
      this.$router.go(-1);
    },
    // 编辑
    editActivity(row) {
      this.disabled = false;
      this.editActivityId = row.Id;
      this.editName = row.PaperName;
      this.TotalScore = row.TotalScore;
      this.editdialogForAddPaper = true;
    },
    sureEditPaper() {
      debugger;
      if (this.editName === '') {
        this.$message.warning('作业名称不可为空');
        return false;
      }
      if (this.TotalScore < 0 || this.TotalScore > 1000) {
        this.$message.warning('总分必须在0~1000之间');
      } else {
        this.$http.post('/api/XOrg/BookMaterial/updatePaperName',{
          paperId: this.editActivityId,
          paperName: this.editName
        }).then( rst => {
            if (rst.code > 0) {
              this.$message.success(rst.msg);
              this.editdialogForAddPaper = false;
              this.getPaperList(1);
            } else {
              this.$message.warning(rst.msg);
            }
        });
        this.$http.post('/api/XOrg/BookMaterial/updatePaperScore',{
          paperId: this.editActivityId,
          totalScore: this.TotalScore
        }).then( rst => {
          if (rst.code > 0) {
            this.$message.success(rst.msg);
            this.editdialogForAddPaper = false;
            this.getPaperList(1);
          } else {
            this.$message.warning(rst.msg);
          }
        });
      }
    },
    lessonAfter(command) {
      switch (command) {
        case 'source':
          this.$router.push({

            name: 'Courseware',
            params: { courseId: this.newCourseId, folderId: '0' }
          });
          break;

        case 'questions':
          this.$router.push({
            name: 'QuestionWarehouse',
            params: {
              courseId: this.newCourseId
            }
          });
          break;

        case 'teachers':
          this.$router.push({

            name: 'CourseTeacherList',
            params: {
              courseId: this.newCourseId
            }
          });
          break;

        case 'works':
          this.$router.push({

            name: 'Paper',
            params: {
              courseId: this.newCourseId
            }
          });
          break;

        case 'activity':
          this.$router.push({

            name: 'BrainstormingCourse',
            params: {
              courseId: this.newCourseId
            }
          });
          break;
      }
    },
    /** 返回列表 */
    getPaperList(page) {
      this.loadingShow = true;
      this.$http.post('/api/XOrg/BookMaterial/getPaperList',{
        paperType: this.paperType,
        courseId: this.courseId,
        page: page,
        paperName: this.paperName,
        pageSize: this.pageSize
      }).then( rst => {
        this.list = rst.list;
        this.loadingShow = false;

        if (this.list.length === 0) {
          this.noDataShow = true;
        } else {
          this.noDataShow = false;
        }
        this.totalCount = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
        this.myid = rst.myid;
        this.otherid = rst.otherid;
      })
    },
    onPageChangeHandler(page) {
      this.getPaperList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPaperList(1);
    },
    /* 颜色切换 */
    changeQuesType1: function() {
      this.active = 1;
    },
    changeQuesType2: function() {
      this.active = 2;
    },
    /** 新增 */
    openAddPaperDialog() {
      this.dialogForAddPaper = true;
    },
    /* 添加题目 */
    sureAddPaper(Number) {
      this.addType = Number;
      this.$http.post('/api/XOrg/BookMaterial/addPapperInfo',{
         courseId: this.courseId, 
         paperType: this.addType, 
         paperName: this.addName
      }).then( rst => {
        if (rst.code > 0) {
          this.dialogForAddPaper = false;
          this.openDetails(this.addType, rst.paperId);
        } else {
          this.$message({ type: 'warning', message: rst.msg });
        }
      })
    },
    cancelAddPaper() {
      this.dialogForAddPaper = false;
      this.editdialogForAddPaper = false;

      this.addType = '1';
      this.addName = '';
      this.editName = '';
      this.editActivityId = '';
      this.TotalScore = '';
    },
    /** 删除 */
    delPaper(paperId) {
       let self = this;
      this.$confirm('此操作将删除该作业,是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          debugger
          if(self.list.length==1){
            self.pageIndex=self.pageIndex-1;
          }
          this.$http.post('/api/XOrg/BookMaterial/deletePaperById',{
            ids: paperId
          }).then(rst => {
            self.getPaperList(self.pageIndex);
          })
          this.$http.post('/api/XOrg/BookMaterial/deletePaperById',{
            ids: paperId
          }).then(rst => {
            if (rst.code > 0) {
              this.$message({ type: 'success', message: rst.msg });
              this.getPaperList(this.pageIndex);
            } else {
              this.$message({ type: 'warning', message: rst.msg });
            }
          })
        })
        .catch(() => {});
    },
    // 查看
    checkhomework(type, paperId) {
      this.courseId = this.courseId;
      debugger;
      if (type === 1) {
        this.$router.push({

          name: 'checkschoolehomework',
          params: {
            courseId: this.courseId,
            paperId: paperId
          }
        });
      } else if (type === 4) {
        this.$router.push({

          name: 'checkschoolEnclosure',
          params: {
            courseId: this.courseId,
            paperId: paperId
          }
        });
      }
    },
    /** 详情 */
    openDetails(type, paperId) {
      this.courseId = this.courseId;

      if (type === 1) {
        this.$router.push({
          // name: "OnLineQuestion", // 题库作业 路由
          // name: "homework",

          name: 'teaHomework_bank',
          params: {
            courseId: this.courseId,
            paperId: paperId
          }
        });
      } else if (type === 2) {
        this.getPaperList();
      } else if (type === 4) {
        this.$router.push({

          name: 'teaEnclosureQuestion', // 附件作业 路由
          params: {
            courseId: this.courseId,
            paperId: paperId
          }
        });
      } else {
        this.$message({ type: 'warning', msg: '发生错误' });
      }
    },
    changeMenu: function() {
      this.menuShow = !this.menuShow;
    },
    // 导入作业
    importPaper() {
      ImportPaper(this.ids, this.courseId).then(
        rst => {
          if (rst.code > 0) {
            this.importDialog = false;
            this.getPaperList(1);
            this.$message.success(rst.msg);
          } else {
            this.$message.warning(rst.msg);
          }
        }
      );
    }
  }
};
</script>

<style lang="scss">
.yk-interactions__container {
  .yk-add-paper-btn-wrapper {
    float: left;
    width: 28%;
    padding: 10px;
    text-align: center;
    font-size: 17px;
    color: #fff;
    border-radius: 10px;
    border: 1px dashed #fff;
    cursor: pointer;
    .wl-icon-tianjia1,.wl-icon-daoru1 {
      margin-right: 10px;
      font-size: 25px;
      border-radius: 50%;
      border: 1px solid #fff;
      vertical-align: -2px;
    }
    .wl-icon-daoru1{
      border:none;
    }
  }
  .yk-add-paper-btn-wrapper1 {
    margin-left: 5%;
  }
  .yk-add-paper-btn-wrapper2 {
    margin-left: 5%;
  }
  .yk-interactions--inner-s {
    padding: 0 40px;
    margin-top: 20px;
    .el-table__header-wrapper {
      th {
        background-color: #293241;
      }
    }
  }
  .yk-interactions--header {
    padding: 10px 40px;
    border-bottom: 1px solid #505e75;
    .yk--sourse-nemu-btn-wrapper {
      float: right;
      width: 90px;
      height: 32px;
      background: #3fa2ff;
      border-radius: 3px;
      line-height: 32px;
      text-align: center;
      color: #fff;
      margin-left: 10px;
      .el-dropdown-link {
        font-size: 11px;
      }
    }
  }
  .el-table__empty-text {
    color: #fff;
  }
}
.yk-interactions__container-new {
  .el-input__inner {
    height: 32px;
  }
  .headClearfix:after {
    content: "";
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
  }
  .yk-intera-head-title {
    float: left;
    font-size: 18px;
    // font-weight: bold;
    color: #fff;
    margin-top: 5px;
  }
  .yk-intera-head-form {
    float: right;
  }
  .el-dropdown-link {
    font-size: 11px;
  }
  .yk-btn-new-back-s {
    position: fixed;
    right: 53px;
    top: 10px;
    z-index: 2000;
    padding: 2px 10px;
    .wl-icon-fanhui2 {
      font-size: 29px;
    }
  }
  .el-pagination__total{
    margin-right: 10px;
    font-weight: 400;
    color: #fff;
  }
  .el-pagination__jump{
    margin-left: 24px;
    font-weight: 400;
    color: #fff;
  }
}
.paper-import-homework{
  .el-dialog__footer{
    border: 1px solid #EDF2F6;
  }
}
  .yk-interactions__container{
    .yk-add-paper-btn-wrapper{
      color: #000;
      border-color: #000;
      .wl-icon-tianjia1{
        border-color:#000;
      } 
    }
    .yk-interactions--header{
      border: none;
    }
    .yk-interactions--inner-s{
      .el-table__header-wrapper{
        th{
          background-color:#e9eff5;
        }
      } 
      .el-table thead tr .cell {
        color:#333;
        font-weight: 600;
      }
      .el-table .cell{
        text-align: center;
        color: #266299;
      }
    }
    .change-search-in-wrapper-1{
      .el-input__inner{
        background-color: #edf2f6;
        border-color: #edf2f6;
        color: #000;
      }
    }  
  } 
  .yk-table-dark.el-table tr, .yk-table-dark.el-table td{
    background-color: #fff;
  }
  .yk-table-dark.el-table--striped .el-table__body tr.el-table__row--striped td{
    background-color: #FAFAFA;
  }
  .yk-table-dark.el-table--enable-row-hover .el-table__body tr:hover > td{
    background-color:#F5F7FA;
  }
  .el-pagination.is-background {
    text-align: center;
    margin-top: 20px;
    padding-bottom: 20px;
}
</style>
